<template>
    <!--
          作者：kmdshop
          时间：2023-06-02
          描述：组件-选择公司
      -->
    <el-dialog title="选择公司" :visible.sync="dialogVisible" :append-to-body="true" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
   

          <el-form-item label="状态">
            <el-select size="small" v-model="formInline.status" placeholder="所有状态">
                <el-option label="全部" value=""></el-option>
                <el-option :label="item.name" v-for="(item,index) in status_arr" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否删除">
            <el-select size="small" v-model="formInline.is_delete" >
                <el-option label="全部" value=""></el-option>
                <el-option label="未删除" :value="0"></el-option>
                <el-option label="已删除" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input placeholder="请输入公司名称" v-model="formInline.search">
              <el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="list" border style="width: 100%" highlight-current-row v-loading="loading" @selection-change="tableCurrentChange">
  
            <el-table-column prop="name" label="公司名称"></el-table-column>
            <el-table-column prop="address" label="公司地址"></el-table-column>
            <el-table-column prop="legal_person" label="法定代表人"></el-table-column>
            <el-table-column prop="phone"  label="电话"></el-table-column>
            <el-table-column prop="email"  label="邮箱"></el-table-column>
            <el-table-column prop="status.text"  label="状态"></el-table-column>
            <el-table-column prop="create_time" width="140" label="添加时间"></el-table-column>
            <el-table-column prop="is_delete.text"  label="是否删除"></el-table-column>
            <el-table-column type="selection" :selectable="selectableFunc" width="44" v-if="islist"></el-table-column>
            <el-table-column width="80" label="单选" v-if="!islist">
              <template slot-scope="scope">
                <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
                <el-button size="mini" v-else disabled>已选</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClerk" v-if="islist">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
 import PasswordApi from '@/api/password.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        formInline: {
            "status":"",
            "search":"",
            "is_delete":""
        },
        //商品分类列表
        cateList: [],
        //商品列表
        list: [],
        multipleSelection: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*结果类别*/
        type:'error',
        /*传出去的参数*/
        params:null,
        status_arr:[]
      };
    },
    props: ['company_show', 'excludeIds_company','islist'],
    // watch:{
    //     company_show:function(n,o){
    //     if(n!=o){
    //       if(n){
    //         console.log(n)
    //         this.dialogVisible=n;
    //         this.type='error';
    //         this.params=null;
    //         this.getData();
    //       }
    //     }
    //   }
    // },
    created() {
        console.log(this.company_show)
        this.dialogVisible=this.company_show;
        this.getData();
        var self = this;
        PasswordApi.getCompanyStatus({}).then(data => {
            self.status_arr = data.data;
          }).catch(error => {
        });
    },
    methods: {
  
      /*是否可以勾选*/
      selectableFunc(e){
        if(typeof e.noChoose !=='boolean'){
          return true;
        }
        return e.noChoose;
      },
  
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
  
      /*获取商品列表*/
      getData() {
        console.log("走了吗")
        let self = this;
        let params = self.formInline;
        params["listRow"] = JSON.stringify({
            "page": self.curPage,
            "list_rows":self.pageSize,
        })
        PasswordApi.getCompany(params, true)
          .then(res => {
            if (res.code == 1) {
              self.loading = false;
              self.cateList = res.data.category;
              /*判断是否需要去重*/
              if(self.excludeIds_company&&typeof(self.excludeIds_company)!='undefined'&&self.excludeIds_company.length>0){
                res.data.list.data.forEach(item=>{
                  if(self.excludeIds_company.indexOf(item.company_id)>-1){
                    item.noChoose=false;
                  }else{
                    item.noChoose=true;
                  }
                });
              }else{
                if(!self.islist){
                   res.data.list.data.forEach(item=>{
                     item.noChoose=true;
                   });
                }
              }
              self.list = res.data.list.data;
              self.totalDataNumber = res.data.list.total;
            }
          })
          .catch(error => {});
      },
  
      /*单选*/
      SingleFunc(row){
        this.multipleSelection=[row];
        this.addClerk();
      },
  
      //点击确定
      addClerk() {
        let self = this;
        let params = null;
        let type = 'success';
        console.log("list",self.list)
        console.log("this.multipleSelection ",this.multipleSelection )
        if (self.multipleSelection.length < 1) {
          self.$message({
            message: '请至少选择一家公司！',
            type: 'error'
          });
          return;
        }
         params = self.multipleSelection;
         self.params = params;
         self.type = 'success';
         self.dialogVisible = false;
      },
  
      /*关闭弹窗*/
      dialogFormVisible() {
        this.$emit('closeDialog', {
          type: this.type,
          openDialog: false,
          params: this.params
        });
      },
  
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
      }
    }
  };
  </script>
  
  <style>
   .no-list .el-checkbox{ display: none;}
  </style>
  


// WEBPACK FOOTER //
// src/components/company/company.vue